<template>
  <div class="main" id="main">
    <div class="tuo tuo1" @mousedown="move">
      1
    </div>
    <div class="tuo tuo2" @mousedown="move">
      2
    </div>
    <div class="tuo tuo3" @mousedown="move">
      3
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      positionX: 0,
      positionY: 0
    };
  },

  mounted() {},
  methods: {
    move(e) {
      let odiv = e.target; //获取目标元素
      let oMark = document.createElement("div"); //创建要拖拽的元素
      // 布局赋给新的元素
      oMark.style.width = odiv.offsetWidth + "px";
      oMark.style.height = odiv.offsetHeight + "px";
      oMark.style.left = odiv.offsetLeft + "px";
      oMark.style.right = odiv.offsetTop + "px";
      // 类名
      oMark.className = "mark";
      // 内容
      oMark.innerHTML = "拖拽对象";
      // append到对应容器内
      document.getElementById("main").appendChild(oMark);
      let disX = e.clientX - oMark.offsetLeft;
      let disY = e.clientY - oMark.offsetTop;
      // 鼠标移动
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        oMark.style.left = left + "px";
        oMark.style.top = top + "px";
      };
      // 鼠标抬开
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
        oMark.onmousedown = this.moveTo;
      };
    },
    moveTo(e) {
      let odiv = e.target; //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        //移动当前元素
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.main {
  width: 1100px;
  height: 600px;
  position: relative;
  .mark {
    position: absolute;
    background: red;
  }
  .tuo {
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: pink;
  }
  .tuo1 {
    position: absolute;
    left: 10px;
    top: 10px;
  }
  .tuo2 {
    position: absolute;
    left: 60px;
    top: 10px;
  }
  .tuo3 {
    position: absolute;
    left: 110px;
    top: 10px;
  }
}
.left {
  width: 500px;
  height: 500px;
  float: left;
  border: 1px solid;
}
.right {
  width: 500px;
  height: 500px;
  float: left;
  border: 1px solid;
}
</style>
